import { useMemo } from 'react';
import { useCatalogSuppliers } from '../../catalog/hooks/useStoreCatalog';
import { buildSupplierMentionTerms, type SupplierMentionTerms } from '../lib/editorialLeak';

/** Términos de proveedor oculto (nombre, dominio, email) leídos de merchandising.suppliers. */
export function useSupplierMentionTerms(): SupplierMentionTerms {
    const suppliersQ = useCatalogSuppliers();
    return useMemo(() => buildSupplierMentionTerms(suppliersQ.data ?? []), [suppliersQ.data]);
}
